<template>
    <div class="data_management_wrap">
        <div class="data_management_left">
            <ul>
                <li>
                    <div class="top custom_hover_active_class  font_bold" :class="approval_set_id == '' ? 'active' : ''" @click="handleClickTabList({id:''})">
                        <span class="ellipsis">全部数据</span>
                    </div>
                </li>
                <li v-for="item in typeList">
                    <div class="top custom_hover_active_class  font_bold" :class="item.is_down_up ? 'is_down_up' : ''" @click="handleClickTab(item)">
                        <i class="iconfont el-icon-caret-right"></i> <span class="ellipsis" v-text="item.name"></span>
                    </div>
                    <div class="bottom " v-if="item.approvals && item.approvals.length>0 && item.is_down_up">
                        <p class="ellipsis custom_hover_active_class  font_bold" :class="list.id == approval_set_id ? 'active' : ''" @click="handleClickTabList(list)" v-for="list in item.approvals" v-text="list.name"></p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="data_management_right" v-loading="loading">
            <div class="data_management_right_search">
                <el-input  v-model="searchForm.keyword" size="small"  placeholder="请输入审批编号/提交人"   suffix-icon="el-icon-search"  clearable  @clear="handleClickSearch"  @keyup.enter.native="handleClickSearch"></el-input>
            </div>
            <div class="data_management_right_table">
               <CustomVxeTable
                ref="tableRef"
                class="custom-table"
                id="approvalDataManagement"
                :tableData="tableData"
                :reduceHeight="reduceHeight"
                :isShowToolBar="true"
                :empty-render="{ name: 'NotData' }"
                :pagination.sync="pagination"
                @handleCurrentChange="handleCurrentChange"
                @handleSizeChange="handleSizeChange"
                :customConfig="tableCustomConfig">
                <vxe-column field="approval_set_name" title="审批类型"  min-width="184" show-overflow></vxe-column>
                <vxe-column field="approval_id" title="审批编号"  min-width="120" show-overflow>
                    <template #default="{ row }">
                       <span v-text="'ID:'+ row.approval_id"></span>
                    </template>
                </vxe-column>
                <vxe-column field="creator_info" title="提交人"  min-width="142" show-overflow>
                    <template #default="{ row }">
                        <userDetailPopover :uid="row.creator_info.id" v-if="row.creator_info">
                            <div slot="container">
                                <div class="user_head ellipsis" >
                                    <img :src="row.creator_info.avatar ?  row.creator_info.avatar: defaultImg"  alt="">
                                    <span class="ellipsis" v-text="row.creator_info.name"></span>
                                </div>
                            </div>
                        </userDetailPopover>
                    </template>
                </vxe-column>
                <vxe-column field="approval_status" title="状态"  min-width="78" show-overflow>
                    <template #default="{ row }">
                        <span v-if="row.approval_status == 0" class="approval_status approval_status0">待审批</span>
                        <span v-if="row.approval_status == 1" class="approval_status approval_status1">已通过</span>
                        <span v-if="row.approval_status == 2" class="approval_status approval_status2">已驳回</span>
                        <span v-if="row.approval_status == 3" class="approval_status approval_status3">已撤回</span>
                    </template>
                </vxe-column>
                <vxe-column field="approval_created_at" title="审批提交时间"  min-width="160" show-overflow></vxe-column>
                <vxe-column field="approval_end_at" title="审批结束时间"  min-width="160" show-overflow>
                    <template #default="{ row }">
                        <span v-text="row.approval_end_at ? row.approval_end_at : '--'"></span>
                    </template>
                </vxe-column>
                <vxe-column field="processer_info" title="当前处理人"  min-width="142" show-overflow>
                    <template #default="{ row }">
                        <div class="flex_js_wrap" v-if="row.processer_info && row.processer_info.length > 0 && row.processer_info[0] && row.processer_info[0].id">
                            <userDetailPopover :uid="row.processer_info[0].id">
                                <div slot="container">
                                    <div class="user_head ellipsis" >
                                        <img :src="row.processer_info[0].avatar ?  row.processer_info[0].avatar: defaultImg"  alt="">
                                        <span class="ellipsis" v-text="row.processer_info[0].name"></span>
                                    </div>
                                </div>
                            </userDetailPopover>
                            <span v-if="row.processer_info.length - 1 > 0">+{{row.processer_info.length - 1}}</span>
                        </div>
                        <span v-if="!row.processer_info || row.processer_info.length == 0">
                            --
                        </span>
                    </template>
                </vxe-column>
                <vxe-column field="operate" width="90" fixed="right">
                    <template #header>
                        <span>操作</span>
                        <el-tooltip class="item" effect="dark" content="表头设置" placement="bottom-start">
                            <i class="iconfont icon-biaotoushezhi table-header-icon" @click="handleClickCustom"></i>
                        </el-tooltip>
                    </template>
                    <template #default="{ row }">
                        <div class="table-operate-icon">
                            <el-button type="text" @click="handleClickApprovalDetail(row)">详情</el-button>
                        </div>
                    </template>
                </vxe-column>
                <template #empty>
                    <div class="custom-table-empty">
                        <div class="custom-table-empty-img"></div>
                        <p class="custom-table-empty-txt">暂无数据</p>
                    </div>
                </template>
            </CustomVxeTable>
            </div>

        </div>
    </div>
</template>

<script>
import CustomVxeTable from "@/components/pComponents/vxe-table";
import userDetailPopover from "@/components/pComponents/userDetailPopover";
import {getTableHeight} from '@/utils'
import {pagination} from '@/mixins'
import { approvalSetList ,approvalDataList} from "@/api/index.js"
export default {
    name: "dataManagement",
    components: {
        CustomVxeTable,
        userDetailPopover
    },
    data() {
        return {
            defaultImg: require("@/assets/images/default.jpg"),
            loading:false,
            typeList:[ ],
            searchForm:{
                keyword:''
            },
            approval_set_id:0,
            tableData:[],
            tableCustomConfig: {
                storage:true,
                allowFixed: false,
                confirmButtonText: "确定",
                resetButtonText: "重置",
                visibleMethod: (col) => {
                    return true;
                },
                checkMethod: (col) => {
                    return col.column.field !== "operate";
                },
                allowSort: true,
            },
        }
    },
    mixins: [pagination],
    created() {
        this.getApprovalTypeData()
        this.getApprovalDataList()
    },
    computed: {
        reduceHeight() {
            return  this.tableData.length ? 218 : 172;
        },
    },
    mounted() {

    },
    methods: {
        // 审批详情
        handleClickApprovalDetail(row) {
            this.$showApprovalDetail({
                approval_id: row.approval_id,
            }).then((res) => {
                console.log(res);
            });
        },
        getApprovalTypeData(){
            approvalSetList().then(res=> {
                if(res.code === 200) {
                    this.typeList = res.data
                }
            })
        },
        getApprovalDataList(){
            let postData = {
                page: this.pagination.page,
                pageSize: this.pagination.pageSize,
                keyword: this.searchForm.keyword,
                approval_set_id:this.approval_set_id
            }
            this.loading = true
            approvalDataList(postData).then(res=> {
                if(res.code === 200) {
                    let {list,total} = res.data
                    this.tableData = list
                    this.pagination.total = total
                }
                this.loading = false
            })
        },
        handleClickTab(item){
            this.$set(item,'is_down_up',!item.is_down_up)
            this.$forceUpdate()
        },
        handleClickTabList(list){
            this.approval_set_id = list.id
            this.pagination.pageNum = 1
            this.getApprovalDataList()
        },
           // 表头配置
        handleClickCustom() {
            this.$refs.tableRef.handleOpenCustomShow();
        },
        handleClickSearch(){
            this.pagination.pageNum = 1
            this.getApprovalDataList()
        },

        handleSizeChange(val) {
            this.pagination.pageNum = 1
            this.pagination.pageSize = val
            this.getApprovalDataList()
        },
        handleCurrentChange(val) {
            this.pagination.pageNum = val
            this.getApprovalDataList()
        },

    }
}
</script>

<style lang="scss" scoped>
    .data_management_wrap{
        width: 100%;
        height: calc(100vh  - 90px);
        display: flex;
        justify-content: space-between;
        .data_management_left{
            width: 262px;
            border-right: 1px solid rgba(232, 232, 232, 1);
            padding: 8px;
            box-sizing: border-box;
            overflow: auto;
            ul{
                width: 100%;
                li{
                    width: 100%;
                    .top{
                        padding: 0 16px;
                        width: 100%;
                        line-height: 38px;
                        border-radius: 6px;
                        cursor: pointer;
                        box-sizing: border-box;
                        display: flex;
                        align-items: center;
                        i{
                            color: rgba(102, 102, 102, 1);
                        }
                        span{
                            color: rgba(102, 102, 102, 1);
                        }
                        &.is_down_up i{
                            transform: rotate(90deg);
                        }
                    }
                    .bottom{
                        width: 100%;
                        p{
                            line-height: 38px;
                            height: 38px;
                            color: rgba(102, 102, 102, 1);
                            font-size: 14px;
                            padding-left: 32px;
                            box-sizing: border-box;
                            border-radius: 6px;
                            &.active{
                                color: rgb(41, 144, 255);
                            }
                        }
                    }
                }
            }
        }
        .data_management_right{
            width: calc(100% - 262px);
            padding:0 16px;
            box-sizing: border-box;
            .data_management_right_search{
                padding: 16px 0;
                .el-input{
                    width: 262px;
                }
            }
            ::v-deep .vxe-table{
                margin-top: 0;
            }

            .approval_status{
                padding-left: 10px;
                position: relative;
                color: rgb(102, 102, 102);
                font-size: 14px;
                &:before{
                    width: 6px;
                    height: 6px;
                    border-radius: 50%;
                    position: absolute;
                    left: 0;
                    top: 7px;
                    content: ' ';
                }
                &.approval_status0:before{
                    background: rgba(240, 170, 50, 1);
                }
                &.approval_status1:before{
                    background: rgba(90, 179, 51, 1);
                }
                &.approval_status2:before{
                    background: rgba(228, 65, 68, 1);
                }
                &.approval_status3:before{
                    background: rgb(153, 153, 153);
                }

            }
            .user_head{
                width: 100%;
                line-height: 24px;
                display: flex;
                align-items: center;
                cursor: pointer;
                img{
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                    display: inline-block;
                    margin-right: 8px;
                }
                span{
                    font-size: 14px;
                    color: rgb(102, 102, 102);
                }
            }
        }
    }
</style>